import { React } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from '@fs/zion-router'
import { ResponsiveTableRow, Expander, ExpanderHeader, ExpanderContent, Separator, H5 } from '@fs/zion-ui'
import { DmcResponsiveTable } from '../../common/DmcResponsiveTable'
import { getIdElement } from '../../../util/StringUtil'
import { CisLink } from '../../app/Links'
import DmcCopyToClipboardTooltip from '../../../util/DmcCopyToClipboardTooltip'

/**
 * Displays information about the patron who uploaded this artifact
 */
export default function PatronPanel({ patron }) {
  const [t] = useTranslation()
  const title = t('artifacts.uploaderInfo', 'Uploader Info')
  const columnHeaders = ['', ' ']

  return (
    <Expander>
      <ExpanderHeader>
        <H5>{title}</H5>
      </ExpanderHeader>
      <ExpanderContent>
        <DmcResponsiveTable
          totalColumnCount={columnHeaders.length}
          atSizeColumns={{
            default: {
              labels: columnHeaders,
            },
          }}
          separator={<br />}
        >
          <ResponsiveTableRow column1={t('name', 'Name')} column2={patron.name} />
          <ResponsiveTableRow column1={t('userName', 'Username')} column2={patron.userName} />
          <ResponsiveTableRow
            column1={t('email', 'Email')}
            column2={patron.email && <a href={`mailto:${patron.email}`}>{patron.email}</a>}
          />
          <ResponsiveTableRow
            column1={t('artifacts.patronId', 'Patron ID')}
            column2={
              <div>
                {patron.id}
                <br />
                <Link to={`/artifacts/patron/mp.${patron.id}`} target="_blank" noScrollTop>
                  {t('artifacts.viewPatronArtifacts', 'View patron’s artifacts')}
                </Link>
              </div>
            }
          />
          <ResponsiveTableRow column1={t('account.status', 'Account Status')} column2={patron.status} />
          <ResponsiveTableRow
            column1={t('cisUserId', 'CIS User ID')}
            column2={
              patron?.cisUserId?.startsWith('cis.user') ? (
                <div>
                  <DmcCopyToClipboardTooltip value={getIdElement(patron.cisUserId)} />
                  <br />
                  <CisLink
                    userId={getIdElement(patron.cisUserId)}
                    text={t('artifacts.viewUserSummary', 'View user summary')}
                  />
                </div>
              ) : (
                <div>
                  <DmcCopyToClipboardTooltip value={patron.cisUserId} />
                  <Separator />
                </div>
              )
            }
          />
        </DmcResponsiveTable>
      </ExpanderContent>
    </Expander>
  )
}
